module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0003#_Toc81914978"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Present Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0005#_Toc81914980"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("One Year Ago: Neil & Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0005#_Toc81914982"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0006#_Toc81914983",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0008#_Toc81914984",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0010#_Toc81914985",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0012#_Toc81914986",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0013#_Toc81914987",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0015#_Toc81914988",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0017#_Toc81914989",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0018#_Toc81914990",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0019#_Toc81914991",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0020#_Toc81914992",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0021#_Toc81914993",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0022#_Toc81914994",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0024#_Toc81914995",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0025#_Toc81914996",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0026#_Toc81914997",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0026#_Toc81914998",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0029#_Toc81914999",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0030#_Toc81915000",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0032#_Toc81915001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0034#_Toc81915002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0035#_Toc81915003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0036#_Toc81915004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0038#_Toc81915005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0039#_Toc81915006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0040#_Toc81915007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0041#_Toc81915008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0042#_Toc81915009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0044#_Toc81915010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0045#_Toc81915011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Willow")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0047#_Toc81915012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Neil")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0049#_Toc81915013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Brock")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0050#_Toc81915014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Pauleen")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0052#_Toc81915015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Chief Phill")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0053#_Toc81915016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Present Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0055#_Toc81915017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Three Months Later")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0055#_Toc81915017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Acknowledgement")]), _c('span', {
    staticClass: "calibre25"
  }, [_vm._v("s")]), _c('span', {
    staticClass: "calibre26"
  }), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v("151")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre21"
  }, [_c('span', {
    staticClass: "calibre23",
    attrs: {
      "href": "#/text/part0055#_Toc81915017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("Author Bi")]), _c('span', {
    staticClass: "calibre25"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "calibre27"
  }), _c('span', {
    staticClass: "calibre11"
  }, [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre28"
  }, [_c('span', {
    staticClass: "calibre29"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre28"
  }, [_c('span', {
    staticClass: "calibre29"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre30"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre31"
  }, [_c('a', {
    attrs: {
      "id": "_Toc81914978"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54396cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0003.vue
// module id = 69
// module chunks = 0